// Logos des moyens de paiement (cartes en SVG, wallets via les icônes officielles Mollie)
const ICON = "https://www.mollie.com/external/icons/payment-methods";

export const VisaLogo = () => (
  <svg viewBox="0 0 48 30" className="h-6 w-auto rounded-[3px]" aria-label="Visa">
    <rect width="48" height="30" rx="3" fill="#1434CB" />
    <text x="24" y="20.5" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontStyle="italic" fontWeight="900" fontSize="13" fill="#fff">VISA</text>
  </svg>
);

export const MastercardLogo = () => (
  <svg viewBox="0 0 48 30" className="h-6 w-auto rounded-[3px]" aria-label="Mastercard">
    <rect width="48" height="30" rx="3" fill="#252525" />
    <circle cx="19.5" cy="15" r="8" fill="#EB001B" />
    <circle cx="28.5" cy="15" r="8" fill="#F79E1B" />
    <path d="M24 8.4a8 8 0 0 1 0 13.2a8 8 0 0 1 0-13.2z" fill="#FF5F00" />
  </svg>
);

export const AmexLogo = () => (
  <svg viewBox="0 0 48 30" className="h-6 w-auto rounded-[3px]" aria-label="American Express">
    <rect width="48" height="30" rx="3" fill="#1F72CD" />
    <text x="24" y="13.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="6.5" fill="#fff">AMERICAN</text>
    <text x="24" y="21.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="6.5" fill="#fff">EXPRESS</text>
  </svg>
);

export const MethodIcon = ({ id }) => (
  <span className="h-7 min-w-[44px] px-1.5 rounded-md border border-stone-200 bg-white flex items-center justify-center">
    <img src={`${ICON}/${id}.svg`} alt={id} className="h-5 w-auto" />
  </span>
);
